export const TOKEN_CREATED = "TOKEN_CREATED";

export const setTokenCreated = (data:any) => {
    return{
        type:TOKEN_CREATED,
        payload:data
    }
}